var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-year"},_vm._l((_vm.monthList),function(month,index){return _c('month-box',{key:index,attrs:{"month":index,"year":_vm.selectedYear,"taskCount":_vm.taskCount}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }